<section class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading"> Manage Locations</h1>
    <app-navpath />
  </div>
  <div class="mb-2 flex w-fit gap-1">
    <button class="shorter-btn add-btn" (click)="addEntry()">
      <fa-icon [icon]="faPlus" class="mr-1"></fa-icon>Add
    </button>

    <button class="shorter-btn delete-btn" (click)="deleteSelectedEntries()">
      <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>Delete
    </button>
  </div>
  <div class="content-container">
    <app-data-table
      [tableHeaders]="tableHeaders"
      [tableEntries]="tableEntries"
      (open)="openEntry($event)"
      [pagination]="false"
    ></app-data-table>
  </div>
</section>
